import { Pipe, PipeTransform } from '@angular/core';
import { AttributeDefinition } from '../models/attributes/attributeDefinition';

@Pipe({
  name: 'customFieldTypeIcon',
  standalone: false
})
export class CustomFieldTypeIconPipe implements PipeTransform {
  transform(attributeDef: AttributeDefinition): string {
    return attributeDef.getIcon();
  }
}
